import request from "@/utils/request";
import commMethods from "@/assets/ts/common";

interface Obituary {
    "categoryName": string,
    categoryParentId: string | number
}

export function reload() {
    return {
        // categoryName:'',
        // categoryParentId:''
    }
}

const baseUrl = "WeChatObituary/";
const weChatObituaryApi = {

//详情
    detail(id:string) {
        return request.get(`${baseUrl}GeObiturayDetail?id=` + id)
    },
    // //讣告视图详情
    // detail(id:string){
    //     return request.get(`${baseUrl}GeObiturayDetail?weChatId=` + id)
    // },
    //更改  0 新增 1 编辑
    updateOrAdd(type:number, data:any) {
        return request[type ? "put" : "post"](baseUrl + (type ? 'UpdateObituary' : 'CreateObituary'), data)
    },
    //删除
    del(id:string) {
        return request.del(`${baseUrl}RemoveObituary?id=` + id)
    },
    //转发讣告
    share(id:string){
        return request.get(`${baseUrl}ObituaryShare?obituaryId=` + id)
    },
    /**
     客户领取讣告
     "id": 0,
     "weChatId": 0,
     "merchantId": 0,
     "wechatUserId": 0,
     "receivePhone": "string",
     "createTime": "2024-07-17T10:52:34.175Z",
     "merchantCustomerId": 0
     **/
    receiveObituary(data: any) {
        return request.post(`${baseUrl}ReceiveObituary`, data)
    },
    //讣告流览统计
    view(id:string) {
        return request.get(`${baseUrl}GetObiturayView?obituaryId=` + id)
    },
    // 讣告详情商家信息
    getObituaryMerchant(obituaryId: string) {
        return request.get(`${baseUrl}GetObituaryMerchant?obituaryId=`+obituaryId)
    },
    //发布讣告留言
    createObituaryMessage(data: any) {
        return request.post(`${baseUrl}CreateObituaryMessage`, data)
    },
    //讣告详情留言列表
    getObituaryMessge(current: number,weChatId:string) {
        return request.post(`${baseUrl}GetObituaryMessge`, {
            "orderByFiled": "Id",
            "isAsc": true,
            "offset":current,
            "limit": 20,
            "queryOptions": {
                weChatId
            }
        })
    },
    //讣告留言列表 不分页
    getObituaryMessgeList(obituaryId:string){
        return request.post(`${baseUrl}GetObituaryMessgeList`, {
            obituaryId
        })
    },
    //获取讣告背景音乐
    getBackGroundMusicList(){
        return request.post(`${baseUrl}GetBackGroundMusicList`,{})
    },

    getBackgroundMusic(id:string){
        return request.get(`${baseUrl}GetBackgroundMusic?id=${id}`  )
    },
    //讣告开关
    /**
     * "id": "string",
     * "isrelease": true
     */
    updateSysObituaryRelease(data:any){
        return request.post(`${baseUrl}UpdateSysObituaryRelease`,data)
    },
}
export default weChatObituaryApi;